import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, Unique, UpdateDateColumn, VersionColumn } from "typeorm";
import { IceTypeEnum, SupplierTypeEnum, VehicleTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
@Entity("vehicle_assignment")
export class VehicleAssignment {
    @PrimaryGeneratedColumn("increment", { name: 'vehicle_assign_id' })
    vehicleAssignId: number;

    @Column({
        nullable: false,
        name: "assigned_date"
    })
    assignedDate: Date;

    @Column("int", {
        nullable: true,
        name: "driver_id"
    })
    driverId: number;

    @Column("varchar", {
        nullable: false,
        name: "vehicle_num"
    })
    vehicleNo: string;

    @Column("varchar", {
        nullable: false,
        name: "ice_factory"
    })
    iceFactory: string;
    @Column( "enum",{
        // type: 'enum',
        enum: VehicleTypeEnum,
        nullable: false,
        // default: VehicleTypeEnum.OWN,
        name: 'vehicle_type'
    })
    vehicleType: VehicleTypeEnum; 

    @Column({
        type: 'enum',
        enum: IceTypeEnum,
        nullable: false,
        // default: VehicleTypeEnum.OWN,
        name: 'ice_type'
    })
    iceType: IceTypeEnum; 

    @Column("int", {
        nullable: false,
        name: "ice_quantity"
    })
    iceQuantity: number;

    @Column("date",{
        nullable: false,
        name: "harvesting_date"
    })
    harvestingDate: Date;

    @Column({
        type: 'enum',
        enum: HarvestingTime,
        nullable: false,
        default: HarvestingTime.MORNING,
        name: 'harvesting_time'
    })
    harvestingTime: HarvestingTime;      

    @Column("int", {
        nullable: false,
        name: "indent_id"
    })
    indentId: number;

    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column("varchar", {
        nullable: true,
        name: "driver_name"
    })
    driverName: string;
}

